import { useState } from 'react';
import { Steps, Button, notification, Tabs } from 'antd';
import { useHistory } from 'react-router-dom';
import Questionnaire from 'components/Questionnaire';
import { activityConfig } from './assessmentConfigs/activityConfig';
import { mentalityConfig } from './assessmentConfigs/mentalityConfig';
import { communicateConfig } from './assessmentConfigs/communicateConfig';
import { socialConfig } from './assessmentConfigs/socialConfig';
import './style.less';
const { TabPane } = Tabs;
const { Step } = Steps;
const Assessment = () => {
    const history = useHistory();
    const [current, setCurrent] = useState(0);
    const [results, setResults] = useState({});
    const [nursingArea, setNursingArea] = useState('');
    const [totalResScore, setTotalResScore] = useState('');

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const handleFinish = (resObj, type) => {
        const newResults = { ...(results || {}), [type]: resObj };
        const resKeys = Object.keys(newResults || {});
        if (resKeys.length === 4) {
            sessionStorage.setItem('assessmentRes', JSON.stringify(newResults));
            let totalResScore = 0;
            resKeys.forEach(key => {
                totalResScore = newResults[key].totalScore + totalResScore;
            });
            let nursingArea = '';
            switch (true) {
                case totalResScore <= 80:
                    nursingArea = '全护理区';
                    break;
                case totalResScore <= 90 && totalResScore > 80:
                    nursingArea = '半护理区';
                    break;
                default:
                    nursingArea = '自理区';
                    break;
            }
            setTotalResScore(totalResScore);
            setNursingArea(nursingArea);
        }
        setResults(newResults);
    };

    const otherNode = (
        <div className="stepsAction">
            {current < 4 && (
                <Button type="primary" onClick={next}>
                    后一项
                </Button>
            )}
            {current > 0 && (
                <Button style={{ marginLeft: 10 }} onClick={prev}>
                    前一项
                </Button>
            )}
        </div>
    );

    const goApply = () => {
        const resKeys = Object.keys(results || {});
        if (resKeys.length === 4) {
            history.push('/userApply/fillInBaseInfo');
        } else {
            notification.warning({
                message: '请先完成所有评估表',
            });
        }
    };

    const steps = [
        {
            title: '日常生活活动能力评估表',
            key: 'activity',
            content: (
                <Questionnaire
                    qusConfig={activityConfig}
                    formName="activity"
                    onFinish={resObj => handleFinish(resObj, 'activity')}
                    otherNode={otherNode}
                />
            ),
        },
        {
            title: '精神状态评估表',
            key: 'mentality',
            content: (
                <Questionnaire
                    formName="mentality"
                    qusConfig={mentalityConfig}
                    onFinish={resObj => handleFinish(resObj, 'mentality')}
                    otherNode={otherNode}
                />
            ),
        },
        {
            title: '感知觉与沟通评估表',
            key: 'communicate',
            content: (
                <Questionnaire
                    formName="communicate"
                    qusConfig={communicateConfig}
                    onFinish={resObj => handleFinish(resObj, 'communicate')}
                    otherNode={otherNode}
                />
            ),
        },
        {
            title: '社会参与评估表',
            key: 'social',
            content: (
                <Questionnaire
                    formName="social"
                    qusConfig={socialConfig}
                    onFinish={resObj => handleFinish(resObj, 'social')}
                    otherNode={otherNode}
                />
            ),
        },
        {
            title: '评估结果',
            key: 'assessmentRes',
            content: (
                <div className="assessmentRes">
                    {[
                        { key: 'activity', text: '日常生活活动能力评估表' },
                        { key: 'mentality', text: '精神状态评估表' },
                        { key: 'communicate', text: '感知觉与沟通评估表' },
                        { key: 'social', text: '社会参与评估表' },
                    ].map((item, index) => {
                        return (
                            <div className="resItem" key={`item${index}`}>
                                <span className="itemTitle">{item.text}：</span>
                                <span className="itemRes">
                                    {results[item.key] ? (
                                        <span>
                                            {results[item.key].totalScore}分--
                                            {results[item.key].res}
                                        </span>
                                    ) : (
                                        <span>
                                            评估表未完成，
                                            <span
                                                className="actionText"
                                                onClick={() => setCurrent(index)}>
                                                点击前往
                                            </span>
                                        </span>
                                    )}
                                </span>
                            </div>
                        );
                    })}
                    <div className="resItem" style={{ fontSize: 18, fontWeight: 600 }}>
                        <span className="itemTitle">推荐护理区：</span>
                        <span className="itemRes">
                            {nursingArea
                                ? `总分${totalResScore}--${nursingArea}`
                                : '完成全部评估表可查看'}
                        </span>
                    </div>
                    <div className="submitBtn">
                        <Button type="primary" onClick={goApply}>
                            开始填写申请
                        </Button>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="assessmentBox">
            <Steps current={current} onChange={current => setCurrent(current)} type="navigation">
                {steps.map((item, index) => {
                    const status =
                        current === index ? 'process' : results[item.key] ? 'finish' : 'wait';
                    return <Step key={item.key} title={item.title} status={status} />;
                })}
            </Steps>
            <div className="stepsContent">
                <Tabs activeKey={current + ''}>
                    {steps.map((step, index) => {
                        return <TabPane key={index}>{step.content}</TabPane>;
                    })}
                </Tabs>
            </div>
        </div>
    );
};
export default Assessment;
